import { PopoverListButtonItem } from '../popover-list-button';

export const DOWNLOAD_LINK_MENU_ITEMS: PopoverListButtonItem[] = [
  {
    label: 'Excel',
    key: 'excel',
    icon: 'file-excel',
  },
  {
    label: 'CSV',
    key: 'csv',
    icon: 'file-csv',
  },
  {
    label: 'TSV',
    key: 'tsv',
    icon: 'file-export',
  },
];
